module.exports.stickerSize = 80;
